<template>
	<report-page
		:start-date="true"
		:end-date="true"
		get-url="/bo/report/customerservice/sentemails"
		title="Sent Emails"
		export-filename="sent_emails"
	/>
</template>

<script>

export default {
	name: 'SentEmailsReport'

};
</script>
